import * as React from "react";
const SvgFiBrandsSlidesgo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-slidesgo_svg__a)">
      <path d="M22.53 2.5 7.84.08h-.16c-.48 0-.87.36-.87.87V2.1l13.38 2.19c.95.16 1.67.99 1.67 1.99v11.49l1.11.2h.16c.48 0 .87-.36.87-.87V4.21c-.04-.87-.64-1.59-1.47-1.71" />
      <path d="M19.18 5.53 4.45 3.1h-.16c-.48 0-.87.36-.87.87v1.19l13.26 2.19c.95.16 1.67.99 1.67 1.99v11.52l1.11.2h.16c.48 0 .87-.36.87-.87V7.08c0-.76-.56-1.43-1.31-1.55" />
      <path d="M15.72 8.43 1.03 6H.87C.39 6 0 6.36 0 6.87v13.35c0 .6.44 1.11 1.03 1.19l15.05 2.5h.16c.48 0 .87-.36.87-.87V10.06c-.04-.8-.6-1.47-1.39-1.63m-9.08 9.18c0 .28-.36.4-.56.2l-3.59-3.3c-.2-.16-.2-.48 0-.56l3.59-2.07c.24-.12.56.08.56.4zm7.52-1.19-3.58 2.15c-.24.16-.56-.08-.56-.4V12.8c0-.28.32-.4.56-.2l3.59 3.22c.19.2.19.48 0 .6z" />
    </g>
    <defs>
      <clipPath id="fi-brands-slidesgo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsSlidesgo;
